package top.wcpe.allincore.ui.runtime.event

import top.wcpe.allincore.ui.runtime.element.UIElement

/** 按稳定元素树构造平台无关的输入目标路径。 */
object TargetPathResolver {

    /** 解析从 [root] 到 [target] 的路径；目标不在当前树中时返回空串。 */
    fun resolve(root: UIElement<*>?, target: UIElement<*>?): String {
        if (root == null || target == null) return ""
        val path = ArrayList<UIElement<*>>()
        if (!findPath(root, target, path)) return ""

        val duplicateIds = duplicateIdOrdinals(root)
        return path.mapIndexed { index, element ->
            segment(element, if (index == 0) null else path[index - 1], duplicateIds)
        }.joinToString("/")
    }

    private fun findPath(node: UIElement<*>, target: UIElement<*>, path: MutableList<UIElement<*>>): Boolean {
        path.add(node)
        if (node === target) return true
        for (child in node.children()) {
            if (findPath(child, target, path)) return true
        }
        path.removeAt(path.lastIndex)
        return false
    }

    private fun duplicateIdOrdinals(root: UIElement<*>): Map<String, Map<UIElement<*>, Int>> {
        val elementsById = LinkedHashMap<String, MutableList<UIElement<*>>>()
        collectIds(root, elementsById)
        return elementsById.mapValues { (_, elements) ->
            elements.mapIndexed { index, element -> element to index }.toMap()
        }
    }

    private fun collectIds(node: UIElement<*>, elementsById: MutableMap<String, MutableList<UIElement<*>>>) {
        val id = node.id()
        if (!id.isNullOrEmpty()) elementsById.getOrPut(id) { ArrayList() }.add(node)
        node.children().forEach { collectIds(it, elementsById) }
    }

    private fun segment(
        element: UIElement<*>,
        parent: UIElement<*>?,
        duplicateIds: Map<String, Map<UIElement<*>, Int>>,
    ): String {
        val id = element.id()
        if (!id.isNullOrEmpty()) {
            val ordinals = duplicateIds[id].orEmpty()
            val suffix = if (ordinals.size > 1) "[${ordinals.getValue(element)}]" else ""
            return "#${escapeId(id)}$suffix"
        }
        val kind = stableKind(element)
        val ordinal = parent?.children()
            ?.filter { stableKind(it) == kind }
            ?.indexOfFirst { it === element }
            ?.coerceAtLeast(0)
            ?: 0
        return "$kind[$ordinal]"
    }

    private fun escapeId(id: String): String = id.replace("~", "~0").replace("/", "~1")

    private fun stableKind(element: UIElement<*>): String {
        val name = element::class.simpleName ?: return "element"
        return name.replaceFirstChar { it.lowercase() }
    }
}
